// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sok_wrapper__nxyCO","paginationBtn":"sok_paginationBtn__YwIIV","pageBtn":"sok_pageBtn__Je4yt","pageBtnSelected":"sok_pageBtnSelected__6S8_y"};